import script from "./report-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./report-detail.vue?vue&type=script&lang=ts&setup=true"

import "./report-detail.vue?vue&type=style&index=0&id=7d4d1022&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d4d1022"]])

export default __exports__